import React from 'react';
import { ZapIcon, CheckCircleIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="w-full bg-[#0b0b0b] py-20 md:py-32 px-4 relative overflow-hidden border-t border-white/5" data-id="element-326">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#c9a24a]/10 via-transparent to-transparent pointer-events-none" data-id="element-327"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-328">
        <div className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#c9a24a]/20 to-[#b8913f]/20 border border-[#c9a24a]/30 text-[#c9a24a] px-4 py-2 rounded-full text-[10px] md:text-sm font-black uppercase tracking-widest mb-6 md:mb-10 shadow-[0_0_15px_rgba(201,162,74,0.1)]" data-id="element-329">
          <ZapIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-330" />
          La solución definitiva
        </div>

        <h2 className="text-3xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-8 md:mb-12" data-id="element-331">
          Esto no es{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#e53935] to-[#ef5350] underline decoration-[#c9a24a]/50 underline-offset-8" data-id="element-332">
            otro curso más
          </span>
        </h2>

        <div className="bg-[#141418] border border-white/10 rounded-2xl md:rounded-3xl p-8 md:p-16 shadow-2xl relative overflow-hidden" data-id="element-333">
          {/* Subtle pattern inside card */}
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-5 pointer-events-none" data-id="element-334"></div>

          <p className="text-xl md:text-4xl font-black text-gray-200 leading-snug md:leading-tight mb-8 relative z-10" data-id="element-335">
            Método Barber Pro es un sistema pensado para que{' '}
            <span className="text-white bg-[#c9a24a]/20 px-2 py-1 rounded-md border border-[#c9a24a]/30" data-id="element-336">
              entiendas lo que hacés
            </span>
            , mejores tus resultados y{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#e53935] to-[#ef5350]" data-id="element-337">
              dejes de improvisar.
            </span>
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 pt-6 border-t border-white/10 relative z-10" data-id="element-338">
            <div className="flex items-center gap-2 text-gray-400 font-semibold text-sm md:text-lg" data-id="element-339">
              <CheckCircleIcon className="w-5 h-5 text-[#c9a24a]" data-id="element-340" />
              Paso a paso real
            </div>
            <div className="hidden md:block w-1.5 h-1.5 rounded-full bg-white/20" data-id="element-341"></div>
            <div className="flex items-center gap-2 text-gray-400 font-semibold text-sm md:text-lg" data-id="element-342">
              <CheckCircleIcon className="w-5 h-5 text-[#c9a24a]" data-id="element-343" />
              Resultados desde el día 1
            </div>
          </div>
        </div>
      </div>
    </section>;
}